import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*global $*/

import React from "react";
import store from "@/store/store";
import { dispatchThunk } from "@/store/dispatchThunk";
import { currentContactSelector } from "@/store/chat/contacts/Selectors";
import { currentContactDraftSelector } from "@/store/chat/messages/Selectors";
import { saveMessageDraft, sendMessage } from "@/store/chat/messages/Actions";
import { UrlHelperExtensions } from "@/url_helpers";
import { assert } from "@/common/assert";
import { simpleAlert } from "@/pages/modules/alerts";
import "inline-attachment/src/inline-attachment";
import "inline-attachment/src/input.inline-attachment";
import { KEY_VALUES } from "@/consts";
import ReactModal from "react-modal";
import { formatImageUrl } from "@/common/utils";
import { fhtCommonEnv } from "@/common/fhtGlobalEnv";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";

var ChatInputTextArea =
/** @class */
function (_super) {
  __extends(ChatInputTextArea, _super);

  function ChatInputTextArea(props) {
    var _this = _super.call(this, props) || this;

    _this.myRef = /*#__PURE__*/React.createRef();

    _this.getOwnState = function () {
      var state = store.getState();
      var currentContactFromStore = currentContactSelector(state);

      var currentContactRemainsSame = _this.state && _this.state.currentContact && currentContactFromStore && currentContactFromStore.chatId.encode() === _this.state.currentContact.chatId.encode();

      var inputText = currentContactRemainsSame ? _this.state.inputText : currentContactDraftSelector(state) || "";
      return {
        currentContact: currentContactFromStore,
        inputText: inputText,
        isDraggedOver: false
      };
    };

    _this.onStoreChange = function () {
      if (_this._isMounted) {
        _this.setState(_this.getOwnState());
      }
    };

    _this.handleCloseModal = function () {
      _this.setState({
        uploadingImage: undefined
      });
    };

    _this.handleConfirmModal = function () {
      assert(_this.state.uploadingImage, "uploadingImage falsy");

      _this.props.onImageUploaded(_this.state.uploadingImage);

      _this.setState({
        uploadingImage: undefined
      });
    };

    _this.saveDraft = function () {
      store.dispatch(saveMessageDraft(_this.state.currentContact, _this.state.inputText));
    };

    _this.onDragEnter = function () {
      _this.setState({
        isDraggedOver: true
      });
    };

    _this.onDragLeave = function () {
      _this.setState({
        isDraggedOver: false
      });
    };

    _this.onTextChange = function (e) {
      _this.setState({
        inputText: e.target.value
      });
    };

    _this.checkIsAllWhiteSpace = function () {
      var text = _this.state.inputText;
      var isAllWhiteSpace = /^\s*$/.test(text);

      if (isAllWhiteSpace) {
        simpleAlert("内容不能为空！");
        return true;
      }
    };

    _this.onKeyPress = function (e) {
      if (e.key === KEY_VALUES.ENTER && !e.ctrlKey && !e.altKey && !e.shiftKey) {
        e.preventDefault();

        var textWithEndNewLineTrimed = _this.state.inputText.substr(0, _this.state.inputText.length - 1);

        _this.setState({
          inputText: textWithEndNewLineTrimed
        }, function () {
          _this.handleTextSubmit();
        });
      }
    };

    _this.handleTextSubmit = function () {
      var text = _this.state.inputText;

      if (_this.checkIsAllWhiteSpace()) {
        return;
      }

      if (text.length > 500) {
        simpleAlert("发送的信息过长，请分条发送");
        return;
      }

      var msg = {
        to: _this.state.currentContact,
        type: "text",
        text: text
      };
      dispatchThunk(store, sendMessage(msg));

      _this.setState({
        inputText: ""
      });
    };

    _this.state = _this.getOwnState();
    _this._isMounted = false;
    return _this;
  }

  ChatInputTextArea.prototype.componentDidMount = function () {
    this._isMounted = true;
    var self = this;
    var el = this.myRef.current;
    var UPLOAD_URL = fhtCommonEnv.Hosts.FhtWebUrlRoot + UrlHelperExtensions.FileUploadUrl;
    window.inlineAttachment.editors.input.attachToInput(el, {
      progressText: "",
      uploadUrl: UPLOAD_URL,
      onFileUploadResponse: function onFileUploadResponse(xhr) {
        assert(typeof xhr.readyState === "number", "xhr.readyState not number");
        var result = JSON.parse(xhr.responseText);
        assert(result, "result falsy");
        assert(result.url, "url fasly");
        var readyState = xhr.readyState;
        assert(typeof readyState === "number", "readyState not number");

        if (readyState === 4) {
          self.setState({
            uploadingImage: result
          });
        }

        if (self._isMounted) {
          self.setState({
            isDraggedOver: false
          });
        }
      }
    });
    $(el).on("dragenter.chatinputtextarea.fht360", this.onDragEnter);
    $(el).on("dragleave.chatinputtextarea.fht360", this.onDragLeave);
    $(el).on("keyup.chatinputtextarea.fht360", this.onKeyPress);
    this.unsubscribe = store.subscribe(this.onStoreChange);
  };

  ChatInputTextArea.prototype.UNSAFE_componentWillUpdate = function (nextProps, nextState) {
    var currentContactSwitched = nextState.currentContact.chatId.encode() !== this.state.currentContact.chatId.encode();

    if (currentContactSwitched) {
      this.saveDraft();
    }
  };

  ChatInputTextArea.prototype.componentWillUnmount = function () {
    this._isMounted = false;
    var el = this.myRef.current;
    $(el).off("dragenter.chatinputtextarea.fht360");
    $(el).off("dragleave.chatinputtextarea.fht360");
    $(el).off("keyup.chatinputtextarea.fht360");
    this.saveDraft();
    this.unsubscribe && this.unsubscribe();
  };

  ChatInputTextArea.prototype.appendEmoji = function (emoji) {
    this.setState({
      inputText: this.state.inputText + emoji.code
    });
  };

  ChatInputTextArea.prototype.render = function () {
    var klassName = "chat-input-area__input-area";

    if (this.state.isDraggedOver) {
      klassName += " chat-input-area--dragged-over";
    }

    return _jsxs(React.Fragment, {
      children: [_jsx("div", __assign({
        className: "chat-input-area__send-button settings-theme_color",
        onClick: this.handleTextSubmit
      }, {
        children: "\u53D1\u9001"
      }), void 0), _jsx("textarea", {
        ref: this.myRef,
        className: klassName,
        placeholder: "\u8DDFTA\u8BF4\u70B9\u4EC0\u4E48...",
        onChange: this.onTextChange,
        value: this.state.inputText
      }, void 0), this.state.uploadingImage && _jsxs(ReactModal, __assign({
        isOpen: Boolean(this.state.uploadingImage),
        contentLabel: "\u786E\u8BA4\u53D1\u9001\u56FE\u7247",
        className: "send-image-modal",
        overlayClassName: "send-image-overlay",
        ariaHideApp: false,
        shouldCloseOnEsc: true,
        onRequestClose: this.handleCloseModal,
        shouldFocusAfterRender: true,
        shouldCloseOnOverlayClick: true
      }, {
        children: [_jsxs("div", __assign({
          className: "send-image-modal__content"
        }, {
          children: [_jsx("h3", __assign({
            className: "send-image-modal__title"
          }, {
            children: "\u53D1\u9001\u56FE\u7247"
          }), void 0), _jsx("img", {
            className: "send-image-modal__img",
            src: formatImageUrl(this.state.uploadingImage.url, ImageSizeTypeEnum.Large)
          }, void 0)]
        }), void 0), _jsxs("div", __assign({
          className: "send-image-modal__btns"
        }, {
          children: [_jsx("span", __assign({
            onClick: this.handleCloseModal,
            className: "send-image-modal__close-btn"
          }, {
            children: "\u53D6\u6D88"
          }), void 0), _jsx("span", __assign({
            onClick: this.handleConfirmModal,
            className: "send-image-modal__confirm-btn"
          }, {
            children: "\u786E\u8BA4"
          }), void 0)]
        }), void 0)]
      }), void 0)]
    }, void 0);
  };

  return ChatInputTextArea;
}(React.Component);

export default ChatInputTextArea;